module.exports = __webpack_public_path__ + "img/conexiones.73f7e953.png";